import { useSearchParams } from 'react-router-dom';
import { NEW_DOCUMENT_ID, documentPageMode } from '@bms2/shared';
import { QuoteForm } from './QuoteForm';
import { QuotePageRoute } from './QuotePage';
import { RecordPageRoute } from './RecordPage';
import { WorkOrderForm } from './WorkOrderForm';

/**
 * 🔒 A document's page has two modes and the URL carries which (decision 0409).
 * `<list>/new` is the Draft + New opens; `?mode=edit` reopens the form on a
 * stored document; anything else is view mode, which draws the print layout
 * above the document's own tiles.
 *
 * 🔨 The form is keyed to the document it edits, in the route table's own
 * `detailFor`: an unkeyed page carried the last document's draft into the next
 * one, the way a mounted-and-hidden modal did before the review of 2026-09-15.
 */
export function QuoteDocumentRoute({ recordId, apiBaseUrl = '' }: { recordId: string; apiBaseUrl?: string }) {
  const [params] = useSearchParams();
  if (documentPageMode(params.get('mode'), recordId) === 'edit') {
    return <QuoteForm quoteId={recordId === NEW_DOCUMENT_ID ? null : recordId} apiBaseUrl={apiBaseUrl} />;
  }
  // 🔒 View mode is the Quote's own document page, not the Tile Canvas (decision 0470).
  return <QuotePageRoute recordId={recordId} apiBaseUrl={apiBaseUrl} />;
}

export function WorkOrderDocumentRoute({ recordId, apiBaseUrl = '' }: { recordId: string; apiBaseUrl?: string }) {
  const [params] = useSearchParams();
  if (documentPageMode(params.get('mode'), recordId) === 'edit') {
    return <WorkOrderForm workOrderId={recordId === NEW_DOCUMENT_ID ? null : recordId} apiBaseUrl={apiBaseUrl} />;
  }
  return <RecordPageRoute recordType="WorkOrder" apiBaseUrl={apiBaseUrl} />;
}
